import { FC } from "react"

import Skeleton from "./base"

interface Props {
  className?: string
}

const PartialLoader: FC<Props> = ({ className = "w-24 ml-4" }) => (
  <div className="h-full overflow-hidden">
    <div className="bg-white">
      <Skeleton className="w-full">
        <div className="flex justify-center items-center">
          <div className={`h-4 bg-gray-200 rounded-full ${className}`}></div>
        </div>
      </Skeleton>
    </div>
  </div>
)

export default PartialLoader
